/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Tournament_1_HeadingInputs */

const en_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-volume repetition`)
};

const es_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetición de alto volumen`)
};

const de_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholungen in hoher Zahl`)
};

const zh_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大量重复`)
};

const ar_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكرار عالي الحجم`)
};

const fr_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétition à grand volume`)
};

const vi_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lặp lại với khối lượng lớn`)
};

const sw_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marudio ya kiasi kikubwa`)
};

const th_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การตีซ้ำปริมาณมาก`)
};

const bs_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponavljanje velikog volumena`)
};

const ja_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大量の繰り返し`)
};

const ko_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`높은 볼륨 반복`)
};

const pt_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetição de alto volume`)
};

const it_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetizione ad alto volume`)
};

const sv_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Högvolymrepetition`)
};

const nl_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herhaling met een hoog volume`)
};

const da_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mange gentagelser`)
};

const nb_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Høy volum repetisjon`)
};

const fi_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suuren tilavuuden toisto`)
};

const pl_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powtarzanie głośności`)
};

const ru_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Многотомное повторение`)
};

const tr_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüksek hacimli tekrar`)
};

const hi_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उच्च मात्रा पुनरावृत्ति`)
};

const id_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengulangan bervolume tinggi`)
};

const ms_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulangan dalam jumlah tinggi`)
};

const cs_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opakování vysokého objemu`)
};

const el_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επανάληψη μεγάλου όγκου`)
};

const he_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה גבוהה`)
};

const af_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herhaling met 'n hoog volume`)
};

const hu_method_content_step_06_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagy ismétlésszám`)
};

/**
* | output |
* | --- |
* | "High-volume repetition" |
*
* @param {Method_Content_Step_06_Detail_Tournament_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_tournament_1_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Tournament_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Tournament_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_tournament_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_tournament_1_heading(inputs)
	return en_method_content_step_06_detail_tournament_1_heading(inputs)
});